const messages = {
  en: {
    games: 'Games',
    wallets: 'Wallets',
    records: 'Records',
    profile: 'Profile',
    logout: 'Logout',
    login: 'Login',
    loginTitle: 'Player Login',
    account: 'Account',
    password: 'Password',
    loggingIn: 'Logging in...',
    loginFailed: 'Login failed',
    connectionFailed: 'Connection failed',
    loading: 'Loading...',
    loadFailed: 'Load failed',
    search: 'Search',
    noMatch: 'No matches',
    providers: 'Providers',
    recentGames: 'Recently played',
    recentGamesLobby: 'Lobby',
    categories: 'Categories',
    gameList: 'Games',
    noGames: 'No games in this category',
    launch: 'Launch',
    back: '← Back',
    backToProviders: '← Back to providers',
    backToCategories: '← Back to categories',
    backToGames: '← Back to games',
    chooseOpenMethod: 'Choose how to open',
    gameLocale: 'Game language',
    embedGame: 'Embed',
    openNewWindow: 'New Window',
    gameOpenedInNewWindow: 'Game opened in new window',
    gettingGameUrl: 'Getting game URL...',
    launchFailed: 'Launch failed',
    relaunch: 'Relaunch',
    trialPlay: 'Demo',
    realPlay: 'Real Play',
    trialModeBadge: 'Demo Mode',
    gameWallets: 'Game Wallets',
    provider: 'Provider',
    balance: 'Balance',
    actions: 'Actions',
    reload: 'Reload',
    reloadAll: 'Reload All',
    reloadingAll: 'Reloading...',
    returnAll: 'One-click Return',
    returnAllConfirm: 'Transfer all non-zero game wallet balances back to the main wallet?',
    returnAllRunning: 'Transferring...',
    returnAllSuccess: 'One-click return successful',
    returnAllNoBalance: 'All wallets have zero balance, no transfer needed',
    returnAllPartial: 'Transfer completed: {success} succeeded, {fail} failed',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    max: 'Max',
    depositExceedsMain: 'Exceeds main wallet balance',
    withdrawExceedsGame: 'Exceeds game wallet balance',
    amount: 'Amount',
    amountPlaceholder: 'Enter amount',
    confirm: 'Confirm',
    cancel: 'Cancel',
    processing: 'Processing...',
    depositSuccess: 'Deposit success',
    withdrawSuccess: 'Withdraw success',
    operationFailed: 'Operation failed',
    records_: 'Records',
    betLogs: 'Bet Logs',
    betLogDetail: 'Bet Log Detail',
    noRawData: 'No raw data',
    // bet detail labels (ported from minicat)
    record_provider: 'Game Provider',
    record_category: 'Game Category',
    record_game_type: 'Game Type',
    record_bet_num: 'Bet Num',
    payout: 'Payout',
    valid_bet: 'Valid Bet',
    player_win_lose: 'Player Win/Loss',
    record_bet_time: 'Bet time',
    record_settle_time: 'Settle Time',
    settle_status: 'Settle Status',
    settled: 'Settled',
    record_bet_type: 'Bet Type',
    game_result: 'Game Result',
    record_detail: 'Description',
    // bet category mapping (from minicat)
    category_egame: 'E-game',
    category_casino: 'Casino',
    category_cockfight: 'Cockfight',
    category_hashes: 'Hashes',
    category_bingo: 'Bingo',
    category_poker: 'Poker',
    category_sport: 'Sport',
    category_fishing: 'Fishing',
    category_marble: 'Marble',
    category_lottery: 'Lottery',
    category_pvp_poker: 'PvP Poker',
    transactions: 'Transactions',
    noBetLogs: 'No bet logs',
    noTransactions: 'No transactions',
    prevDay: 'Previous day',
    nextDay: 'Next day',
    clear: 'Clear',
    dateModeSingle: 'Single day',
    dateModeRange: 'Range',
    presetToday: 'Today',
    presetYesterday: 'Yesterday',
    presetThisWeek: 'This week',
    presetLastWeek: 'Last week',
    presetThisMonth: 'This month',
    presetLastMonth: 'Last month',
    presetCustom: 'Custom',
    validBetCol: 'Valid Bet',
    channel: 'Channel',
    betId: 'Bet ID',
    apply: 'Apply',
    reset: 'Reset',
    prevPage: 'Prev',
    nextPage: 'Next',
    category: 'Category',
    status: 'Status',
    betAmount: 'Bet Amount',
    netIncome: 'Net Income',
    time: 'Time',
    beforeBalance: 'Before',
    afterBalance: 'After',
    orderType: 'Type',
    txnType_bet: 'Bet',
    txnType_settle: 'Settle',
    txnType_cancel: 'Cancel',
    txnType_resettle: 'Resettle',
    txnType_jackpot: 'Jackpot',
    txnType_deposit: 'Transfer to Game',
    txnType_withdraw: 'Transfer to Main',
    txnType_adjustment: 'Adjustment',
    txnType_all: 'All types',
    summary: 'Summary',
    totalCount: 'Total',
    totalBet: 'Total Bet',
    totalValidBet: 'Valid Bet',
    totalPayout: 'Total Payout',
    totalNetIncome: 'Net Income',
    countSuffix: 'records',
    countUnit: '',
    profileTitle: 'Profile',
    locale: 'Locale',
    save: 'Save',
    saving: 'Saving...',
    saveSuccess: 'Saved',
    saveFailed: 'Save failed',
    tokenExpiresAt: 'Token Expires At',
    refreshBalance: 'Refresh balance',
    lobby: 'Lobby',
    enterLobby: 'Enter Lobby',
    selectProvider: 'Search provider',
    searchGameTitle: 'Search Game',
    searchGameId: 'Search provider / game id',
    searchGameIdDisabled: 'Select a provider first',
    allProviders: 'All providers',
    more: 'More',
    noResults: 'No results',
  },
  'zh-CN': {
    games: '游戏',
    wallets: '钱包',
    records: '记录',
    profile: '个人信息',
    logout: '登出',
    login: '登入',
    loginTitle: '玩家登入',
    account: '帐号',
    password: '密码',
    loggingIn: '登入中...',
    loginFailed: '登入失败',
    connectionFailed: '连线失败',
    loading: '载入中...',
    loadFailed: '载入失败',
    search: '搜寻',
    noMatch: '查无结果',
    providers: '供应商列表',
    recentGames: '最近游玩',
    recentGamesLobby: '大厅',
    categories: '分类列表',
    gameList: '游戏列表',
    noGames: '此分类没有游戏',
    launch: '启动',
    back: '← 返回',
    backToProviders: '← 返回供应商列表',
    backToCategories: '← 返回分类列表',
    backToGames: '← 返回游戏列表',
    chooseOpenMethod: '选择游戏开启方式',
    gameLocale: '游戏语系',
    embedGame: '内嵌游戏',
    openNewWindow: '另开视窗',
    gameOpenedInNewWindow: '游戏已在新视窗开启',
    gettingGameUrl: '取得游戏连结中...',
    launchFailed: '启动失败',
    relaunch: '重新启动',
    trialPlay: '试玩',
    realPlay: '正式游戏',
    trialModeBadge: '试玩模式',
    gameWallets: '游戏钱包',
    provider: '供应商',
    balance: '余额',
    actions: '操作',
    reload: '刷新',
    reloadAll: '全部刷新',
    reloadingAll: '刷新中...',
    returnAll: '全部转回',
    returnAllConfirm: '确定要将所有非零余额的游戏钱包转回主钱包吗？',
    returnAllRunning: '转回中...',
    returnAllSuccess: '全部转回成功',
    returnAllNoBalance: '所有钱包余额为零，无需转回',
    returnAllPartial: '转回完成：成功 {success} 个，失败 {fail} 个',
    deposit: '存款',
    withdraw: '提款',
    max: '全部',
    depositExceedsMain: '超过主钱包余额',
    withdrawExceedsGame: '超过游戏钱包余额',
    amount: '金额',
    amountPlaceholder: '输入金额',
    confirm: '确认',
    cancel: '取消',
    processing: '处理中...',
    depositSuccess: '存款成功',
    withdrawSuccess: '提款成功',
    operationFailed: '操作失败',
    records_: '记录查询',
    betLogs: '投注记录',
    betLogDetail: '注单详情',
    noRawData: '无原始资料',
    // bet detail labels (ported from minicat)
    record_provider: '游戏商',
    record_category: '游戏种类',
    record_game_type: '游戏名称',
    record_bet_num: '游戏商注单号',
    payout: '派彩',
    valid_bet: '有效投注',
    player_win_lose: '玩家 赢/输',
    record_bet_time: '投注时间',
    record_settle_time: '结算时间',
    settle_status: '注单状态',
    settled: '已结算',
    record_bet_type: '投注类型',
    game_result: '游戏结果',
    record_detail: '细节',
    // bet category mapping (from minicat)
    category_egame: '电子游戏',
    category_casino: '真人视讯',
    category_cockfight: '斗鸡',
    category_hashes: '哈希',
    category_bingo: '宾果',
    category_poker: '棋牌游戏',
    category_sport: '体育竞技',
    category_fishing: '捕鱼',
    category_marble: '弹珠',
    category_lottery: '彩票',
    category_pvp_poker: '扑克对战',
    transactions: '交易记录',
    noBetLogs: '尚无投注记录',
    noTransactions: '尚无交易记录',
    prevDay: '前一天',
    nextDay: '后一天',
    clear: '清除',
    dateModeSingle: '单日',
    dateModeRange: '区间',
    presetToday: '今日',
    presetYesterday: '昨日',
    presetThisWeek: '本周',
    presetLastWeek: '上周',
    presetThisMonth: '本月',
    presetLastMonth: '上月',
    presetCustom: '自定义',
    validBetCol: '有效投注',
    channel: 'Channel',
    betId: '注单号',
    apply: '套用',
    reset: '重置',
    prevPage: '上一页',
    nextPage: '下一页',
    category: '分类',
    status: '状态',
    betAmount: '投注额',
    netIncome: '净收入',
    time: '时间',
    beforeBalance: '变动前',
    afterBalance: '变动后',
    orderType: '类型',
    txnType_bet: '下注',
    txnType_settle: '派彩',
    txnType_cancel: '取消',
    txnType_resettle: '重派',
    txnType_jackpot: '彩金',
    txnType_deposit: '转入游戏',
    txnType_withdraw: '转回主钱包',
    txnType_adjustment: '调帐',
    txnType_all: '全部类型',
    summary: '合计',
    totalCount: '总笔数',
    totalBet: '总投注',
    totalValidBet: '有效投注',
    totalPayout: '总派彩',
    totalNetIncome: '净收入',
    countSuffix: '笔',
    countUnit: '笔',
    profileTitle: '个人信息',
    locale: '语系',
    save: '储存',
    saving: '储存中...',
    saveSuccess: '储存成功',
    saveFailed: '储存失败',
    tokenExpiresAt: 'Token 到期时间',
    refreshBalance: '刷新余额',
    lobby: '大厅',
    enterLobby: '进入大厅',
    selectProvider: '搜寻游戏商',
    searchGameTitle: '搜寻游戏',
    searchGameId: '搜寻游戏商 / 游戏 ID',
    searchGameIdDisabled: '请先选择游戏商',
    allProviders: '全部游戏商',
    more: '更多',
    noResults: '无结果',
  }
}

export function useI18n(authStore) {
  function t(key) {
    return messages[authStore.locale]?.[key] || messages.en[key] || key
  }
  return { t }
}
